import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { metaTagsConfig } from '../config/metaTags';

const CanonicalWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  
  const getCanonicalUrl = () => {
    const baseUrl = 'https://www.86400.in';
    let path = location.pathname;

    // Remove trailing slash if present (except for home page)
    if (path.length > 1 && path.endsWith('/')) {
      path = path.slice(0, -1);
    }

    return `${baseUrl}${path}`;
  };

  const getMetaTags = () => {
    const path = location.pathname === '/' ? '/' : location.pathname.replace(/\/$/, '');
    return metaTagsConfig[path] || {
      title: '86400 | Digital Payment Solutions',
      description: '86400 provides secure digital payments infrastructure for banks and fintechs.',
      keywords: 'digital payments, payment infrastructure, fintech solutions'
    };
  };

  const metaTags = getMetaTags();

  return (
    <>
      <Helmet>
        <title>{metaTags.title}</title>
        <meta name="description" content={metaTags.description} />
        <meta name="keywords" content={metaTags.keywords} />
        <link rel="canonical" href={getCanonicalUrl()} />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content={metaTags.title} />
        <meta property="og:description" content={metaTags.description} />
        <meta property="og:url" content={getCanonicalUrl()} />
        <meta property="og:type" content="website" />
        
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaTags.title} />
        <meta name="twitter:description" content={metaTags.description} />

        {/* Additional Meta Tags */}
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      </Helmet>
      {children}
    </>
  );
};

export default CanonicalWrapper;